import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classes from '../PaymentFields.module.css';
export const LabeledField = ({ label, children }) => {
    if (!children) {
        return null;
    }
    return (_jsxs("span", { className: classes.label, children: [_jsx("span", { className: classes.labelSecondary, children: label }), " ", children] }));
};
